// Auth
import { clearActiveAuthDomain } from "Auth/AuthDomain";
import { mbsStorage } from "Auth/MBS/mbsStorage";
import { clearPrimaryStorage } from "Auth/Primary/primaryAuth";

// Constants
import { AUTH_DOMAINS } from "Constants/AuthConstants";

export const getAuthDomainForPath = (pathname = "") =>
  pathname === "/mbs" || pathname.startsWith("/mbs/")
    ? AUTH_DOMAINS.MBS
    : AUTH_DOMAINS.PRIMARY;

export const clearMFAStorage = () => {
  sessionStorage.removeItem("adminMFA");
  Object.keys(sessionStorage)
    .filter((key) => key.startsWith("2FA"))
    .forEach((key) => sessionStorage.removeItem(key));
};

export const clearAppSessionStorage = () => {
  clearPrimaryStorage();
  mbsStorage.clear();
  clearActiveAuthDomain();
  clearMFAStorage();
};
